<template>
  <div>
    <h5 v-if="!isVisible"
      v-for="(lrDetail,index) in getLrNumberDetails"
      :key="index"
      :class="{'is-select': showEditView(lrDetail) && (index === selectedIndexForLrEdit)}" >
      <div class="d-flex">
        <label>{{lrDetail.title}}</label>
        <div v-if="$hasFeature('lr_extraction')" class="validation-card">
          <Tooltip v-if="verifyLr(lrDetail.lr_number)" :open-delay="100" effect="dark" placement="bottom-end">
            <div slot="content">Lr number verified</div>
            <i>
              <svgicon name="green-circle-tick" width="14" height="14" :original="true"/>
            </i>
          </Tooltip>
          <Tooltip v-if="lrSummary.length > 0 && !verifyLr(lrDetail.lr_number)" :open-delay="100" effect="dark" placement="bottom-end">
            <div slot="content">LR Number Not Yet Verified</div>
            <i>
              <svgicon name="icon-warning-circle" class="icon" width="14" height="14" :original="true" />
            </i>
          </Tooltip>
        </div>
      </div>
      <span
        class="action-edit"
        v-if="showEditView(lrDetail) && (index === selectedIndexForLrEdit)" >
        <i class="text-grey-medium" @click="closeEditLrView()">
          <svgicon name="icon-close" width="8" height="8" />
        </i>
        <i class="text-blue" @click="saveLrNumber(lrDetail)">
          <svgicon name="icon-tick-sm" width="10" height="10" />
        </i>
      </span>
      <div>
        <Input
          v-if="showEditView(lrDetail) && (index === selectedIndexForLrEdit)"
          @focus="$addGAEvent('Indent Management', 'Text field', 'Documents:LR Number Input Field');"
          :placeholder="$t('INDENT_ENTER_LR_NUMBER')"
          size="mini"
          class="input-blank p-0"
          v-model="enteredLrNumber" />
        <template v-else>
          <div class="form-value">
            <span v-if="lrDetail.lr_number">
              <Ellipsis
                v-bind:text="lrDetail.lr_number"
                :length="25" />
            </span>
            <span v-else-if="!canUpdateLrNumber">-</span>
            <span v-else @click="showEditLrView(index)">{{$t('INDENT_ENTER_LR_NUMBER')}}</span>
          </div>
        </template>
      </div>

      <div class="card-actions">
        <Tooltip :open-delay="100" effect="dark" placement="bottom-end"
          v-if="lrDetail.lr_number && canUpdateLrNumber" >
          <div slot="content">{{$t('INDENT_EDIT_LR')}}</div>
          <i @click="showEditLrView(index)">
            <svgicon name="icon-edit-md" width="14" height="14" :original="true"/>
          </i>
        </Tooltip>
        <Tooltip :open-delay="100" effect="dark" placement="bottom-end"
          v-if="hasGenerateLr && lrDetail.lr_number" >
          <div slot="content">{{$t('INDENT_VIEW_LR')}}</div>
          <i @click="redirectToLrView(index)">
            <svgicon name="icon-view" width="14" height="14" :original="true"/>
          </i>
        </Tooltip>
      </div>
      <div class="popover-custom no-border with-shadow" placement="bottom" v-if="showAlertFlag">
        <div class="popover-body bg-white w-300">
            <p class="mt-5 mb-0 text-sm text-bold">
              {{ $t('CONSIGNMENT_NOT_FOUND_AND_SAVE_LR') }}
            </p>
          <div class="popover-footer">
            <Button type="primary" size="mini" @click="showAlertFlag=false">
            {{$t('CONTINUE')}}
            </Button>
          </div>
        </div>
      </div>
    </h5>
    <div v-if='isFTLIndent && isMaterialLRConfigEnabled' class="d-block">
      <div class="align-item-center justify-content my-10 pb-20">
        <label class="text-xs text-blue-dark3 mr-10 text-bold pl-10">
        Material Invoice - LR Number
        </label>
        <SwitchBtn
        v-model="isVisible"
        :disabled="sourceDestLRCheck"
        size="small"
        class="default-switch mr-10 f-right">
        </SwitchBtn>
        <div v-if="isVisible" class="mt-10">
            <Form class="form-default action-field action-field-form no-hover no-bg">
                <FormItem
                v-for="(invoiceDetails, index) in getMaterialInvoiceLRDetails"
                :key="index"
                :label= "invoiceDetails.invoiceNo"
                class="bg-transparent"
                :class="{ 'active': showInput && (index === selectedIndexForMaterialLREdit), 'no-border': !showInput }"
                >
                    <Input v-if="showInput && (index === selectedIndexForMaterialLREdit)" type="text"
                    placeholder="Enter Material Invoice LR Number"
                    v-model="enteredMaterialInvoiceLR"
                    size="mini" />
                        <div class="item-action" v-if="showInput && (index === selectedIndexForMaterialLREdit)">
                            <i class="secondary" @click="closeEditLrView()">
                            <svgicon name="icon-close" width="9" height="9"/>
                            </i>
                            <i class="primary" @click="saveMaterialInvoiceLevelLR(invoiceDetails, index)">
                            <svgicon name="icon-tick-sm" width="12" height="9"/>
                            </i>
                        </div>
                        <template v-else>
                    <div class="form-value full-width">
                    <span v-if="invoiceDetails.lr_number">
                    <Ellipsis
                    v-bind:text="invoiceDetails.lr_number"
                    :length="25" />
                    <i v-if="canUpdateMaterialInvoiceLR" @click="showEditMaterialLR(index)" class="f-right pointer">
                   <svgicon name="icon-edit-md" width="14" height="14" :original="true"/>
                      </i>
                     </span>
                    <span v-else-if="!canUpdateMaterialInvoiceLR">-</span>
                    <span v-else @click="showEditMaterialLR(index) && canUpdateMaterialInvoiceLR">{{$t('INDENT_ENTER_MATERIAL_INVOICE_LR')}}</span>
                     </div>
        </template>
                </FormItem>
            </Form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isEmpty } from 'lodash';
import { LorryReceiptGenerationCategory } from 'pando-constants';
import LrNumberListShipperMixin from '@/modules-v2/indent/mixins/document/LrNumberListShipperMixin';

export default {
  components: {
  },
  mixins: [LrNumberListShipperMixin],
  data() {
    return {
      enteredLrNumber: null,
      enteredMaterialInvoiceLR: null,
      selectedIndexForLrEdit: -1,
      selectedIndexForMaterialLREdit: -1,
      showInput: false,
      showActions: false,
      showAlertFlag: false,
      isVisible: false,
      isEditable: false,
    };
  },
  props: [
    'destination',
    'lrSummary',
    'isSelectedConsignee',
    'canUpdateLrNumber',
    'canUpdateMaterialInvoiceLR',
    'hasMaterials',
    'canShowConsignmentNumber',
    'hideConsignmentEdit',
    'legalEntityDetails',
  ],
  created() {
    this.isVisible = this.isMaterialLREnabled;
  },
  computed: {
    ...mapGetters({
      configurations: 'app/configurations',
      allMaterials: 'order/materials',
      orderDetails: 'order/find',
      lr: 'order/lr',
      depots: 'app/otherDepots',
      currentClient: 'app/currentClient',
    }),
    showEditView() {
      return (lrDetail) => {
        const lrGenerateCategory = (this.orderDetails && this.orderDetails.lr_type) ||
       (this.configurations && this.configurations.lorry_receipt_generate_category);
        const isMultiDropGateConfig = this.configurations && this.configurations.multi_drop_at_gate_level;
        let divisionWiseEditCheck = true; // checking if the particular division has any associated material in order
        if (lrGenerateCategory === LorryReceiptGenerationCategory.DIVISION_WISE) {
          const destinationId = (isMultiDropGateConfig &&
            this.destination.gate_id) ? this.destination.gate_id : this.destination.location_id;
          const division = lrDetail.division_id || '';
          divisionWiseEditCheck = this.allMaterials.materials.some(
            (material) => {
              const matDivision = material.division || '';
              if (isMultiDropGateConfig && material.destination_gate_id) {
                return material.destination_gate_id === destinationId && (matDivision === division);
              }
              return material.destination_location_id === destinationId && (matDivision === division);
            },
          );
        }
        return this.showActions && this.isSelectedConsignee && this.canUpdateLrNumber && divisionWiseEditCheck;
      };
    },
    getLrNumberDetails() {
      return this.getLrNumberList(this.destination);
    },
    getMaterialInvoiceLRDetails() {
      return this.getMaterialLRList(this.destination);
    },
    hasGenerateLr() {
      return this.hasMaterials && this.$hasFeature('generate_lr');
    },
    isFTLIndent() {
      return this.orderDetails.vehicle_type.type === 'FTL';
    },
    isMaterialLRConfigEnabled() {
      return this.configurations && this.configurations.manual_lr;
    },
    isMaterialLREnabled() {
      if (!this.lr || !this.lr.length) {
        return false;
      }
      const materialInvoiceLR = this.lr.find((lrDetails) => {
        if (this.configurations && this.configurations.multi_drop_at_gate_level
         && lrDetails.gate_id) {
          return (
            lrDetails.destination_location_id === this.destination.location_id &&
            lrDetails.gate_id === this.destination.gate_id &&
            lrDetails.material_invoice_no
          );
        }
        return (
          lrDetails.destination_location_id === this.destination.location_id &&
          lrDetails.material_invoice_no
        );
      });
      return !!materialInvoiceLR;
    },
    sourceDestLRCheck() {
      if (!this.lr || !this.lr.length) {
        return false;
      }
      const sourceDestLR = this.lr.find((lrDetails) => {
        if (this.configurations && this.configurations.multi_drop_at_gate_level
         && lrDetails.gate_id) {
          return (
            lrDetails.destination_location_id === this.destination.location_id &&
            lrDetails.gate_id === this.destination.gate_id &&
            !lrDetails.material_invoice_no
          );
        }
        return (
          lrDetails.destination_location_id === this.destination.location_id &&
          !lrDetails.material_invoice_no
        );
      });
      return !!sourceDestLR;
    },
  },
  methods: {
    toggleVisibility() {
      this.isVisible = !this.isVisible;
    },
    showEditMaterialLR(index) {
      this.showInput = true;
      this.isEditable = true;
      this.selectedIndexForMaterialLREdit = index;
      this.enteredMaterialInvoiceLR = this.getMaterialInvoiceLRDetails && this.getMaterialInvoiceLRDetails[index].lr_number;
    },
    makeEditable() {
      this.isEditable = true;
    },
    showEditLrView(index) {
      this.$addGAEvent('Indent Management', 'Click', 'Documents:Edit LR Number');
      this.selectedIndexForLrEdit = index;
      this.showActions = true;
      this.enteredLrNumber = this.getLrNumberDetails && this.getLrNumberDetails[index].lr_number;
    },
    closeEditLrView() {
      this.isEditable = false;
      this.selectedIndexForLrEdit = -1;
      this.selectedIndexForMaterialLREdit = -1;
      this.showActions = false;
      this.enteredLrNumber = null;
      this.enteredMaterialInvoiceLR = null;
      this.showInput = false;
    },
    verifyLr(currLr) {
      const lrNumbers = this.lrSummary.flatMap((att) => {
        const lr = (att && att.summary && att.summary.document_summary && att.summary.document_summary.arrays
          && (att.summary.document_summary.arrays.lr_numbers || att.summary.document_summary.arrays.lr_number))
          || [];
        return Array.isArray(lr) ? lr : lr ? [lr] : [];
      });
      return lrNumbers.includes(currLr);
    },
    async saveLrNumber(currentDetail) {
      try {
        const orderId = this.orderDetails.order_number;
        const lrGenerateCategory = (this.orderDetails && this.orderDetails.lr_type) ||
       (this.configurations && this.configurations.lorry_receipt_generate_category);
        const isMultiDropGateConfig = this.configurations && this.configurations.multi_drop_at_gate_level;

        const data = {
          destination_id: this.destination.location_id,
          source_location_id: currentDetail.source_location_id ||
            this.destination.source_location_id,
          source_gate_id: currentDetail.source_gate_id ||
            this.destination.source_gate_id || null,
        };
        if (!isEmpty(this.destination.gate_id)) {
          data.gate_id = (currentDetail.legal_entity && currentDetail.legal_entity.gate_id) || this.destination.gate_id;
        }
        if (!isEmpty(this.enteredLrNumber)) {
          data.lr_number = this.enteredLrNumber.trim();
        }
        if (this.$hasFeature('restrict_comma_in_lr') && data.lr_number && data.lr_number.includes(',')) {
          this.$errorMessage({ message: 'Only single LR number allowed per field' });
          return;
        }
        if (lrGenerateCategory === LorryReceiptGenerationCategory.DIVISION_WISE) {
          data.division = currentDetail.division_id;
        } else if (lrGenerateCategory === LorryReceiptGenerationCategory.GATE_WISE
          && (!isEmpty(this.destination.source_gate_id) || !isEmpty(currentDetail.source_gate_id))) {
          data.source_gate_id = currentDetail.source_gate_id || this.destination.source_gate_id;
        } else if (lrGenerateCategory === LorryReceiptGenerationCategory.LEGAL_ENTITY_WISE) {
          data.legal_entity = currentDetail.legal_entity.title;
        }
        const result = await this.$store.dispatch('order/saveLorryReceipt', {
          orderId,
          data: [data],
        });
        if (!result || result.error) {
          if (result && result.error && result.error.includes('LR Number')) {
            this.$errorMessage({
              message: result.error.split(' - Validation  error')[0],
            });
          } else if (result && result.error && result.error.includes('Only single LR number allowed')) {
            this.$errorMessage({ message: 'Only single LR number allowed per field' });
          } else {
            this.$errorMessage({
              message: 'LR number save failed. Please try after some time!',
            });
          }
        } else {
          this.$successMessage({ message: this.$t('INDENT_LR_NUMBER_TOAST_MSG') });
          await this.$emit('loadLrDetails');
          // checking if add_manual_consignment_number config is
          // enabled and if indent status is not [23, 7, 8]
          if (this.canShowConsignmentNumber && !this.hideConsignmentEdit) {
            await this.saveConsignmentNumber(data, isMultiDropGateConfig);
          }
        }
        this.closeEditLrView();
      } catch (error) {
        this.$errorMessage({
          message: 'LR number save failed. Please try after some time!',
        });
      }
    },
    async saveConsignmentNumber(lrData, isMultiDropGateConfig) {
      try {
        this.isLoading = true;
        if (!isEmpty(this.enteredLrNumber)) {
          const orderId = this.orderDetails.order_number;
          const transporterName = this.orderDetails && this.orderDetails.transporter && this.orderDetails.transporter.name;
          let consigneeId = this.destination.location_id;
          if (isMultiDropGateConfig && this.destination.gate_id) {
            consigneeId = this.destination.gate_id;
          }
          const data = {
            consignment_number: this.enteredLrNumber,
            ...lrData,
          };
          setInterval(() => {
            if (this.isLoading) {
              this.$warningMessage({ message: this.$getConst('COURIER_WARNING', { firstArgument: transporterName }) });
            }
          }, 10000);
          const result = await this.$store.dispatch('order/saveConsignmentNumber', {
            orderId,
            consigneeId,
            data,
          });
          if (!result) {
            this.$error({ message: this.$getErr('CONSIGNMENT_UPDATE_FAILURE') });
          } else if (result.error) {
            if (result.error === 'Consignment not found') {
              this.$error({ message: this.$getErr('CONSIGNMENT_UPDATE_INVALID') });
            } else {
              this.$errorMessage({ message: result.error });
              this.showAlertFlag = true;
              this.isConsignmentEdit = false;
              this.$emit('loadConsignmentDetails');
            }
          } else {
            this.isConsignmentEdit = false;
            await this.$emit('loadConsignmentDetails');
            this.$success({ message: this.$getSuccess('CONSIGNMENT_UPDATE_SUCCESS') });
          }
        } else {
          this.$error({ message: 'Please change the consignment number to save!' });
        }
      } catch (error) {
        this.$error({ message: this.$getErr('CONSIGNMENT_UPDATE_FAILURE') });
      } finally {
        this.isLoading = false;
      }
    },
    redirectToLrView(index) {
      this.$addGAEvent('Indent Management', 'Click', 'Documents:View Autogenerated LR');
      const selectedLrDetails = this.getLrNumberDetails[index];
      let url = '';
      const lrDivision = this.orderDetails.lorry_receipt[0] ? this.orderDetails.lorry_receipt[0].division : 'DEFAULT';
      if (selectedLrDetails.division_id) {
        url = this.url(this.orderDetails.order_number,
          selectedLrDetails.division_id, this.destination.location_id);
      } else if (selectedLrDetails.legal_entity) {
        url = this.url(this.orderDetails.order_number,
          lrDivision,
          this.destination.location_id, selectedLrDetails.legal_entity.source_gate_id,
          selectedLrDetails.legal_entity.gate_id, selectedLrDetails.legal_entity.source_location_id,
          selectedLrDetails.legal_entity.title);
      } else if (selectedLrDetails.source_gate_id) {
        url = this.url(this.orderDetails.order_number,
          lrDivision,
          this.destination.location_id, selectedLrDetails.source_gate_id);
      } else {
        url = this.url(this.orderDetails.order_number,
          lrDivision, this.destination.location_id);
      }
      window.open(url, '_blank');
    },
    url(orderNo, division, consigneeId, gateId, destinationGateId, sourceLocationId, legalEntityTitle) {
      const hostname = window.location.host;
      const isDevelopment = hostname.startsWith('localhost') || hostname.startsWith('127.0.0.1');
      const baseURL = isDevelopment ? 'http://localhost:3024/tms-indent/api' : '/tms-indent/api';
      if (gateId) {
        return `${baseURL}/order/lorry_receipt/${btoa(`clientId=${this.currentClient.id}&orderNo=${orderNo}&division=${division}&consigneeId=${consigneeId}&sourceGateId=${gateId}&destinationGateId=${destinationGateId}&sourceLocationId=${sourceLocationId}&legalEntityTitle=${legalEntityTitle}`)}`;
      }
      if (destinationGateId) {
        return `${baseURL}/order/lorry_receipt/${btoa(`clientId=${this.currentClient.id}&orderNo=${orderNo}&division=${division}&consigneeId=${consigneeId}&sourceGateId=${gateId}&destinationGateId=${destinationGateId}&sourceLocationId=${sourceLocationId}&legalEntityTitle=${legalEntityTitle}`)}`;
      }
      return `${baseURL}/order/lorry_receipt/${btoa(`clientId=${this.currentClient.id}&orderNo=${orderNo}&division=${division}&consigneeId=${consigneeId}&sourceLocationId=${sourceLocationId}&legalEntityTitle=${legalEntityTitle}`)}`;
    },
    async saveMaterialInvoiceLevelLR(invoiceDetials, index) {
      const orderId = this.orderDetails.order_number;
      const data = {
        destination_id: this.destination.location_id,
        source_location_id:
            this.destination.source_location_id,
        material_invoice: invoiceDetials.invoiceNo,
      };
      if (!isEmpty(this.destination.gate_id)) {
        data.gate_id = this.destination.gate_id;
      }
      if (!isEmpty(this.enteredMaterialInvoiceLR)) {
        data.lr_number = this.enteredMaterialInvoiceLR.trim();
      }
      if (this.$hasFeature('restrict_comma_in_lr') && data.lr_number && data.lr_number.includes(',')) {
        this.$errorMessage({ message: 'Only single LR number allowed per field' });
        return;
      }
      const result = await this.$store.dispatch('order/saveMaterialInvoiceLR', {
        orderId,
        data: [data],
      });
      if (!result || result.error) {
        if (result && result.error && result.error.includes('LR Number')) {
          this.$errorMessage({
            message: result.error.split(' - Validation  error')[0],
          });
        } else if (result && result.error && result.error.includes('Only single LR number allowed')) {
          this.$errorMessage({ message: 'Only single LR number allowed per field' });
        } else {
          this.$errorMessage({
            message: 'Material Invoice LR number save failed. Please try after some time!',
          });
        }
      } else {
        this.$successMessage({ message: 'Material Invoice LR Number Saved' });
        await this.$emit('loadLrDetails');
      }
      this.closeEditLrView();
    },
  },
};
</script>

<style scoped>
.validation-card{
  margin-top: -3px;
  padding-left: 10px;
}
</style>
